import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';

import { ROUTES } from '@/shared/routes';
import { MainLoader } from '@/shared/ui';
import Oops from '@/shared/widgets/errors/oops';

const StandalonePageProvider: React.FC = () => {
  const { t } = useTranslation();

  return (
    <ErrorBoundary
      onError={console.error}
      fallback={
        <Oops
          redirect={{
            text: t('errors.redirectHome'),
            href: ROUTES.leasing
          }}
        />
      }
    >
      <Suspense fallback={<MainLoader fullScreen />}>
        <Outlet />
      </Suspense>
    </ErrorBoundary>
  );
};

export default StandalonePageProvider;
